'use strict';

import Query from './Query';
import Connection from './Connection';
import PageInfo   from './PageInfo';

export default class ModelQuery extends Query
{
    constructor(model, gql, variables) {
        super(gql, variables);
        this._model = model;
    }

    gql() {
        return this._gql;
    }

    variables() {
        return this._variables;
    }

    parseResponse(result) {

        let total    = result.totalCount ? result.totalCount : 0;
        let edges    = result.edges      ? result.edges      : [];
        let pageInfo = result.pageInfo   ? result.pageInfo   : {};

        let connection = new Connection(total, new PageInfo(pageInfo), []);

        let number = 0;
        for( let edge of edges ) {
            let cursor = edge.hasOwnProperty('cursor') ? edge.cursor : number;
            let node   = edge.hasOwnProperty('node')   ? edge.node   : {};
            
            let obj = this._model.create().fill(node);
            connection.set(cursor, obj);
            number++;
        }

        return connection;
    }

    async fetch() {     
        let model = this._model;
        return await super.fetch();       
    }
}


// WEBPACK FOOTER //
// ./src/graphql/ModelQuery.js